import { render } from "./PaymentAggregation.vue?vue&type=template&id=1b6a00ea&ts=true"
import script from "./PaymentAggregation.vue?vue&type=script&lang=ts"
export * from "./PaymentAggregation.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__